/* eslint-disable */
import _ from 'underscore';
import backbone from 'backbone';
import ko from 'knockout';
import taskProgressTemplate from '@bingads-webui-static-legacy/uet/template/uploadConversions/taskProgress.pug';
import TaskProgressViewModel from '@bingads-webui-static-legacy/uet/viewmodel/uploadConversions/taskProgress';
import config from '@bingads-webui-component-legacy/config/index';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!uet');
var defaults = {
  showProgress: false,
  statusText: '',
  completeText: '',
  completed: 0,
  total: 100
};
function close() {
  this.options.task && this.options.task.trigger('close');
}
var view = backbone.View.extend({
  events: {
    'click .btn-close': close
  },
  initialize: function (options) {
    this.options = options || ({});
    this.options.model = _.defaults({}, this.options.model, defaults);
    this.ko_model = new TaskProgressViewModel(this.options.model);
    this.isNewUI = config.get('IsNewUI');
    if (this.options.task) {
      this.options.task.on('update', (function (completed, total) {
        this.ko_model.showProgress(!this.isNewUI).completed(completed).total(total);
      }).bind(this));
      this.options.task.on('done', (function () {
        this.ko_model.completed(this.ko_model.total());
        this.ko_model.showProgress(false).statusText(this.options.model.completeText);
      }).bind(this));
    }
  },
  render: function () {
    this.$el.html(taskProgressTemplate({
      i18n: i18n,
      isNewUI: this.isNewUI
    }));
    ko.applyBindings(this.ko_model, this.el);
    return this;
  },
  recoverBinding: function () {
    ko.cleanNode(this.el);
    this.undelegateEvents();
    this.delegateEvents();
    ko.applyBindings(this.ko_model, this.el);
  }
});
export default view;

